import { render, staticRenderFns } from "./kfprint.vue?vue&type=template&id=026a80d2"
import script from "./kfprint.vue?vue&type=script&lang=js"
export * from "./kfprint.vue?vue&type=script&lang=js"
import style0 from "./kfprint.vue?vue&type=style&index=0&id=026a80d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports